import styled from 'styled-components';
import MealsSvg from '../../assets/amenities/meals.svg';

const MealsIcon = styled(MealsSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default MealsIcon;
